(() => {
  'use strict';
  const media = window.matchMedia('(max-width:749px), (max-width:999px) and (max-height:600px) and (hover:none) and (pointer:coarse)');
  const states = new Map();
  const rails = new Map();
  let observer, frame = 0;
  const attributes = ['role', 'tabindex', 'aria-label', 'aria-current'];

  function restore(element, saved) {
    attributes.forEach((name, i) => {
      if (saved[i] === null) element.removeAttribute(name);
      else element.setAttribute(name, saved[i]);
    });
  }
  function updateBullets(element, state) {
    const bullets = Array.from(state.swiper.pagination.bullets || []);
    bullets.forEach((bullet, index) => {
      if (!state.bullets.has(bullet)) state.bullets.set(bullet, attributes.map(name => bullet.getAttribute(name)));
      bullet.setAttribute('role', 'button');
      bullet.setAttribute('tabindex', '0');
      if (!bullet.getAttribute('aria-label')) {
        const template = state.swiper.params.a11y?.paginationBulletMessage;
        const heading = element.querySelector(`.swiper-slide[data-swiper-slide-index="${index}"] h2`);
        bullet.setAttribute('aria-label', template ? template.replace('{{index}}', String(index + 1)) : (heading?.textContent.trim() || String(index + 1)));
      }
      bullet.setAttribute('aria-current', String(index === state.swiper.realIndex));
    });
    element.setAttribute('data-ko-mobile-swipe', '');
  }
  function projectIndex(element, state) {
    const left = element.getBoundingClientRect().left;
    return state.cards.reduce((best, card, index) => Math.abs(card.getBoundingClientRect().left - left) < Math.abs(state.cards[best].getBoundingClientRect().left - left) ? index : best, 0);
  }
  function showProject(element, state, index) {
    const target = Math.max(0, Math.min(state.cards.length - 1, index));
    const left = element.scrollLeft + state.cards[target].getBoundingClientRect().left - element.getBoundingClientRect().left;
    element.scrollTo({ left, behavior: window.matchMedia('(prefers-reduced-motion:reduce)').matches ? 'instant' : 'smooth' });
  }
  function scanProjects() {
    const targets = new Set(document.querySelectorAll('#main .knoxone-projects__grid,#main .kb-cards,#main .knoxone-designers__projects-grid'));
    const projectPages = new Set(['/pages/kitchen-systems-in-practice', '/pages/basistem-in-practice-the-noir-wardrobe', '/pages/laundry-space-in-practice']);
    document.querySelectorAll('#main .knox-system-cards-container').forEach(element => {
      if (element.children.length > 1 && Array.from(element.children).every(card => Array.from(card.querySelectorAll('a[href]')).some(link => projectPages.has(link.pathname)))) targets.add(element);
    });
    targets.forEach(element => {
      if (rails.has(element) || element.children.length < 2) return;
      const cards = Array.from(element.children);
      const state = { cards, saved: attributes.map(name => element.getAttribute(name)), text: new Map() };
      element.querySelectorAll('p').forEach(paragraph => {
        const walker = document.createTreeWalker(paragraph, NodeFilter.SHOW_TEXT);
        let node;
        while ((node = walker.nextNode())) {
          if (!node.data.includes(' · ')) continue;
          state.text.set(node, node.data);
          node.data = node.data.replace(/ · /g, '\u00a0· ');
        }
      });
      const pager = document.createElement('div');
      pager.className = 'ko-mobile-project-pagination';
      pager.setAttribute('role', 'group');
      const heading = element.closest('section')?.querySelector('h2')?.textContent.trim();
      if (heading) {
        element.setAttribute('aria-label', heading);
        pager.setAttribute('aria-label', heading);
      }
      element.setAttribute('role', 'region');
      element.setAttribute('tabindex', '0');
      element.setAttribute('data-ko-mobile-projects', '');
      state.buttons = cards.map((card, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.setAttribute('aria-label', card.querySelector('h3')?.textContent.trim() || String(index + 1));
        button.setAttribute('aria-current', String(index === 0));
        button.addEventListener('click', () => showProject(element, state, index));
        pager.appendChild(button);
        return button;
      });
      state.changed = () => {
        const active = projectIndex(element, state);
        state.buttons.forEach((button, index) => button.setAttribute('aria-current', String(index === active)));
      };
      state.key = event => {
        if (event.target !== element || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        showProject(element, state, projectIndex(element, state) + (event.key === 'ArrowRight' ? 1 : -1));
      };
      state.pager = pager;
      rails.set(element, state);
      element.addEventListener('scroll', state.changed, { passive: true });
      element.addEventListener('keydown', state.key);
      element.after(pager);
    });
  }
  function scan() {
    frame = 0;
    if (!media.matches) return;
    document.querySelectorAll('#main custom-swiper').forEach(element => {
      const swiper = element.swiperInstance;
      if (!swiper || swiper.destroyed || swiper.allowTouchMove === false || (swiper.pagination?.bullets?.length || 0) < 2) return;
      let state = states.get(element);
      if (!state) {
        state = { swiper, bullets: new Map(), autoplay: !!swiper.autoplay?.running };
        state.changed = () => updateBullets(element, state);
        states.set(element, state);
        swiper.on('slideChange', state.changed);
        if (state.autoplay) swiper.autoplay.stop();
      }
      updateBullets(element, state);
    });
    scanProjects();
  }
  function schedule() {
    if (!frame && media.matches) frame = window.requestAnimationFrame(scan);
  }
  function activate(event) {
    if (!media.matches || (event.type === 'keydown' && !['Enter', ' '].includes(event.key))) return;
    const bullet = event.target.closest?.('.swiper-pagination-bullet');
    const element = bullet?.closest('custom-swiper[data-ko-mobile-swipe]');
    const state = states.get(element);
    if (!state) return;
    if (event.type === 'click' && state.swiper.params.pagination.clickable) return;
    const index = Array.from(state.swiper.pagination.bullets).indexOf(bullet);
    if (index < 0) return;
    event.preventDefault();
    if (state.swiper.params.loop && typeof state.swiper.slideToLoop === 'function') state.swiper.slideToLoop(index);
    else state.swiper.slideTo(index);
  }
  function changeMode() {
    if (media.matches) {
      document.addEventListener('click', activate);
      document.addEventListener('keydown', activate);
      if (!observer) {
        observer = new MutationObserver(schedule);
        observer.observe(document.querySelector('#main') || document.body, { childList: true, subtree: true });
      }
      schedule();
    } else {
      observer?.disconnect();
      observer = undefined;
      window.cancelAnimationFrame(frame);
      frame = 0;
      document.removeEventListener('click', activate);
      document.removeEventListener('keydown', activate);
      states.forEach((state, element) => {
        element.removeAttribute('data-ko-mobile-swipe');
        state.bullets.forEach((saved, bullet) => restore(bullet, saved));
        if (!state.swiper.destroyed) {
          state.swiper.off('slideChange', state.changed);
          if (state.autoplay) state.swiper.autoplay.start();
        }
      });
      states.clear();
      rails.forEach((state, element) => {
        element.removeAttribute('data-ko-mobile-projects');
        element.removeEventListener('scroll', state.changed);
        element.removeEventListener('keydown', state.key);
        restore(element, state.saved);
        state.text.forEach((text, node) => { node.data = text; });
        state.pager.remove();
      });
      rails.clear();
    }
  }
  function start() {
    media.addEventListener('change', changeMode);
    changeMode();
    window.customElements.whenDefined('custom-swiper').then(schedule);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
